<template>
	<div>
		<div :class="classNames" @click="handleAppointment()">
			<span>{{ getModuleName('appointment') }}</span>
			<svg-icons v-if="dialogType == 'surf'" name="arrow-icon" class="c-action-svg" />
		</div>
		<CDialogSurvey v-if="['PC', 'surf'].includes(dialogType)" :visible.sync="visibleSurvey" />
		<c-mobile-appointment-popup v-else :visible.sync="visibleSurvey" />
	</div>
</template>

<script setup>
import { computed } from 'vue';
import CDialogSurvey from '@/rebuild/materials/shared/appointment/CDialogSurvey.vue';
import CMobileAppointmentPopup from '@/rebuild/materials/shared/appointment/c-mobile-appointment-popup.vue';

import { useCalendarCommon } from './useCalendarCommon';

const { visibleSurvey, handleAppointment, getModuleName } = useCalendarCommon();

const props = defineProps({
	dialogType: {
		type: String,
		default: 'PC'
	}
});

const classNames = computed(() => {
	switch (props.dialogType) {
		case 'PC':
			return 'appointment-btn';
		case 'mobile':
			return 'mobile-btn';
		case 'surf':
			return 'surf-appointment-btn';
		default:
			return 'appointment-btn';
	}
});
</script>

<style lang="less" scoped>
.surf-appointment-btn {
	margin-top: 16px;
	padding: 7px 0;
	color: #000;
	font-family: 'PingFang SC';
	font-size: 14px;
	font-weight: 400;
	line-height: 18px; /* 128.571% */
	border-radius: 4px;
	background: #fff;
	text-align: center;
	cursor: pointer;
	.c-action-svg {
		width: 16px;
		height: 16px;
		margin-left: 4px;
		color: #000 !important;
	}
}
.appointment-btn {
	margin-top: 16px;
	padding: 7px 0;
	color: var(--t-secondary-color, #4e5969);
	font-size: 14px;
	font-weight: 400;
	line-height: 18px; /* 128.571% */
	border-radius: 2px;
	border: 1px solid var(--border-normal-color, #e5e6eb);
	text-align: center;
	cursor: pointer;
}

.mobile-btn {
	display: flex;
	padding: 12px 14px;
	padding-bottom: calc(12px + constant(safe-area-inset-bottom));
	padding-bottom: calc(12px + env(safe-area-inset-bottom));
	box-shadow: 0px -3px 7px rgba(0, 0, 0, 0.02);
	background: #fff;
	span {
		padding: 10px 0;
		flex: 1;
		font-size: 16px;
		text-align: center;
		color: #fff;
		background: var(--theme-color);
	}
}
</style>
